import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { OverridableStringUnion } from "@mui/types";
import { ButtonPropsColorOverrides } from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";

import { useBoolean } from "src/hooks/use-boolean";

import Grid from "@mui/material/Grid";

import { _mock } from "src/_mock";
import { t } from "i18next";
import { useSnackbar } from "src/components/snackbar";
import AuthRegistrationLayout from "src/layouts/auth/registration";
import { useAuthContext } from "src/auth/hooks";
import { JwtRegisterView } from "src/sections/auth/custom";
import { useState } from "react";
import { useParams } from "react-router";
import { useRouter } from "src/routes/hooks";
import { SxProps, Theme } from "@mui/material";
import { getStoredPlacenetToken } from "src/sections/auth/3rdparty/placenetAuth";
// ----------------------------------------------------------------------

type ButtonColor = OverridableStringUnion<
  | "warning"
  | "info"
  | "secondary"
  | "primary"
  | "inherit"
  | "success"
  | "error",
  ButtonPropsColorOverrides
>;

interface Props {
  text?: string | "registration";
  color?: ButtonColor;
  sx?: SxProps<Theme>; // ✅ Add this
}

export default function RegistrationDialog(props: Props) {
  //const dialog = useBoolean();
  const params = useParams();
  const router = useRouter();
  const openDialog = params.dialog === "registration" ? true : false;
  const dialog = useBoolean(openDialog);
  const { register, login } = useAuthContext();
  const { enqueueSnackbar } = useSnackbar();
  const buttonText = props.text || "registration";
  const sx = props.sx;
  const buttonColor: ButtonColor = props.color ? props.color : "secondary";
  const [registrationStep, setRegistrationStep] = useState(0);
  const handleNextButtonClick = () => {
    let newStep = registrationStep + 1;
    if (newStep > 1) {
      //dialog.onFalse();
    } else {
      setRegistrationStep(newStep);
    }
  };

  const handleOnSubmit = async (params: any) => {
    try {
      const placenetToken = getStoredPlacenetToken();

      const user = await register({
        ...params,
        placenet_token: placenetToken,
      });
    } catch (error) {
      enqueueSnackbar(
        typeof error?.detail === "string" ? t(error.detail) : t("platform_legal_error"),
        {
          variant: "error",
        }
      );
    }
  };

  const handlePrevButtonClick = () => {
    let prevStep = registrationStep - 1;
    if (prevStep < 0) {
      dialog.onFalse();
    } else {
      setRegistrationStep(prevStep);
    }
  };

  return (
    <>
      <Button
        variant="contained"
        sx={sx ? sx : { p: { xs: 1, md: 1 } }}
        color={buttonColor}
        onClick={dialog.onTrue}
      >
        {t(buttonText)}
      </Button>

      <Dialog fullScreen open={dialog.value} scroll="body">
        <AuthRegistrationLayout>
          <JwtRegisterView
            registrationStep={registrationStep}
            dialog={dialog}
            handleOnSubmit={handleOnSubmit}
          />

          <DialogActions>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                {registrationStep == 1 && (
                  <Button
                    onClick={handlePrevButtonClick}
                    variant="outlined"
                    color="inherit"
                  >
                    {t("back")}
                  </Button>
                )}
                {/* <Button
                  onClick={handlePrevButtonClick}
                  variant="outlined"
                  color="inherit"
                >
                  {registrationStep == 0 ? t("close") : t("back")}
                </Button> */}
              </Grid>

              <Grid item textAlign={"right"} xs={6}>
                {registrationStep < 1 && (
                  <Button
                    //onClick={dialog.onFalse}
                    onClick={handleNextButtonClick}
                    variant="contained"
                    color="secondary"
                    size="medium"
                  >
                    {t("forward")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </DialogActions>
        </AuthRegistrationLayout>
      </Dialog>
    </>
  );
}
